module.exports = __webpack_public_path__ + "static/header-d7d986b9590179c9791141ee6e52fc6d.mp4";